import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-feedback-rubric',
  templateUrl: './feedback-rubric.component.html',
  styleUrls: ['./feedback-rubric.component.scss']
})
export class FeedbackRubricComponent implements OnInit {
  @Input() modal: any;

  constructor() {}

  public ngOnInit(): void {}

  public doSubmit(): void {
    this.modal.close({
      action: 'save',
      form: 'feedback-rubric',
      formData: true
    });
  }
}
